export interface Environment {
  production: boolean;
  name?: string;
  apiUrl: string;
  appBaseHref: string;
  authUrl: string;
  frontendUrl: string;
  apiBaseUrlForGringotts: string;
  paymentWidgetUrl: string;
  trademeUrl: string;
  tagManagerId: string;
  authClientId: string;
  authScope: string;
}
